import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { SoundEffect } from '../../_services/sound-effect.service';
import { LightshowState } from '../lightshow-state';

@Component({
    selector: 'app-sound-effect-player',
    template: `
    <div (mouseenter)="onMouseEnter()"
         (mouseleave)="onMouseLeave()"
         class="color-container center-items"
         style="flex-direction: column;"
         >

        <div
            [hidden]="hide"
            class="menu-dots justify-content-evenly form-button"
            (click)="openMenu($event)"
            style="z-index: 1;"
        >
            <div></div>
            <div></div>
            <div></div>
        </div>

        <span [hidden]="hide" #title class="center-items text-overflow" style="width:90%">
          {{ soundEffect.title | uppercase }}
        </span>

        <div [hidden]="hide" #buttonsContainer class="btn-container form-button" style="background: white; border-radius: 50%;">
          <img [hidden]="isPlaying" [ngClass]="{'btn-disabled': state.isSoundEffectPlaying}" (click)="play($event)" #playButton src="assets/app/media/img/icons/icons8-play-button-circled-filled-100.png">
          <img [hidden]="!isPlaying" (click)="pause($event)" #pauseButton src="assets/app/media/img/icons/icons8-pause-button-filled-100.png">
        </div>

        <div [hidden]="!hide" class="justify-content-between" style="position: absolute; width: 100%; bottom: 10px;">
            <div class="form-button" (click)="closeMenu($event)" style="margin-left: 10px; z-index: 1;">
                Cancel
            </div>
            <div class="form-button" (click)="delete($event)" style="margin-right: 10px; z-index: 1;">
                Delete
            </div>
        </div>

        <audio #soundEffectMp3 [src]="soundEffect.url"></audio>
    </div>
  `,
    styles: [`
        .btn-container {
            width: 50px;
            height: 50px;
        }

        .btn-container img {
            width: 100%;
            height: 100%;
        }

        .btn-disabled {
            pointer-events: none;
        }
    `]
})

export class SoundEffectPlayerComponent implements AfterViewInit {
    @Input()
    soundEffect: SoundEffect;

    @Input()
    state: LightshowState;

    @Output()
    onDelete = new EventEmitter<any>(true);

    @ViewChild('soundEffectMp3', {static: false}) soundEffectMp3: ElementRef;

    @ViewChild('playButton', {static: false}) playButton: ElementRef;

    @ViewChild('title', {static: false}) title: ElementRef;

    @ViewChild('pauseButton', {static: false}) pauseButton: ElementRef;

    @ViewChild('buttonsContainer', {static: false}) buttonsContainer: ElementRef;

    isPlaying: boolean;

    hide = false;

    ngAfterViewInit() {
        this.buttonsContainer.nativeElement.hidden = true;
        this.title.nativeElement.hidden = false;

        this.soundEffectMp3.nativeElement.onended = () => {
            this.isPlaying = false;
            this.title.nativeElement.hidden = false;
            this.buttonsContainer.nativeElement.hidden = true;
            this.state.isSoundEffectPlaying = false;
        };
    }

    onMouseEnter() {
        if (!this.isPlaying && !this.state.isSoundEffectPlaying && !this.hide) {
            this.title.nativeElement.hidden = true;
            this.buttonsContainer.nativeElement.hidden = false;
        }
    }

    onMouseLeave() {

        if (this.isPlaying) {
            this.title.nativeElement.hidden = true;
            this.buttonsContainer.nativeElement.hidden = false;
        } else if (!this.hide) {
            this.title.nativeElement.hidden = false;
            this.buttonsContainer.nativeElement.hidden = true;
        }
    }

    play(e) {
        if (!this.state.isSoundEffectPlaying) {
            this.state.isSoundEffectPlaying = true;
            this.isPlaying = true;
            this.soundEffectMp3.nativeElement.volume = +localStorage.getItem('playerVolume') / 100 || 0.5;
            this.soundEffectMp3.nativeElement.play();
            this.playButton.nativeElement.hidden = true;
            this.pauseButton.nativeElement.hidden = false;
            e.preventDefault();
            e.stopPropagation();
        }
    }

    pause(e) {
        if (this.isPlaying) {
            this.state.isSoundEffectPlaying = false;
            this.isPlaying = false;
            this.soundEffectMp3.nativeElement.pause();
            this.playButton.nativeElement.hidden = false;
            this.pauseButton.nativeElement.hidden = true;
            e.preventDefault();
            e.stopPropagation();
        }
    }

    delete (e) {

        this.onDelete.emit();
        this.hide = false;
        e.stopPropagation();
    }

    openMenu (e) {

        this.hide = true;
        e.stopPropagation();
    }

    closeMenu (e) {

        this.hide = false;
        e.stopPropagation();
    }
}
